import { ReactNode } from 'react';
// import { ErrorBoundaryProps,ErrorInfo } from '@cbhq/error-vitals-core';
import { ErrorBoundary } from '@cbhq/error-vitals-web';

import { defaultErrorMetadata } from ':support/utils/error-vitals/init';

type ErrorInfo = {
  /**
   * Captures which component contained the exception, and its ancestors.
   */
  componentStack?: string | null;
  digest?: string | null;
};

type AppErrorBoundaryProps = {
  statusCode?: 400 | 404 | 500 | 503;
  errorMsg?: string;
  buttonText?: string;
  isComponentLevel?: boolean;
  children: ReactNode;
  name: string;
  onCatch?: (error: Error, info: ErrorInfo) => void;
  onReset?: () => void;
};

export function AppErrorBoundary({ children, name, onCatch, onReset }: AppErrorBoundaryProps) {
  return (
    <ErrorBoundary
      name={name}
      defaultMetadata={defaultErrorMetadata}
      onCatch={onCatch}
      onReset={onReset}
    >
      {children}
    </ErrorBoundary>
  );
}
